import React from 'react';
import './style.scss';
import Loadable from 'react-loadable';

const VideoInner = Loadable({
  loader: () => import('./VideoInner'),
  loading: () => <div />,
});

const intersectionObserverOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 1,
};

function Video(props) {
  const wrapperRef = React.useRef();

  const [hasIntersected, setHasIntersected] = React.useState(false);

  function onIntersect(entries) {
    const [entry] = entries;

    if (entry.isIntersecting) {
      setHasIntersected(true);
    }
  }

  React.useEffect(() => {
    const observer = new IntersectionObserver(onIntersect, intersectionObserverOptions);

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }

    return () => {
      if (wrapperRef.current) {
        observer.unobserve(wrapperRef.current);
      }
    };

  }, [wrapperRef]);

  return (
    <div className="Video" ref={wrapperRef}>
      {hasIntersected && <VideoInner {...props} />}
    </div>
  );
}


export default Video;
